var map = {
	"./template-10/lotteries/lotteries": "app/styles/client/templates/template-10/lotteries/lotteries",
	"./template-3/lotteries/lotteries": "app/styles/client/templates/template-3/lotteries/lotteries",
	"./template-7/lotteries/lotteries": "app/styles/client/templates/template-7/lotteries/lotteries",
	"./template-9/lotteries/lotteries": "app/styles/client/templates/template-9/lotteries/lotteries"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3863;